import { E2EElement, E2EPage, newE2EPage } from "@stencil/core/testing";

describe("uic-stepper", () => {
    it("buttons increment/decrement value by step size", async () => {
        const page = await newE2EPage({
            html: `<uic-stepper step="2" value="1"></uic-stepper>`
        });

        const component = await page.find("uic-stepper");
        const incButton = await page.find(".uic-stepper__increase");
        const decButton = await page.find(".uic-stepper__decrease");

        await incButton.click();
        await page.waitForChanges();
        expect(await component.getProperty("value")).toEqual(3);

        await decButton.click();
        await page.waitForChanges();
        expect(await component.getProperty("value")).toEqual(1);
    });

    it("buttons emit uicChange", async () => {
        const page = await newE2EPage({
            html: `<uic-stepper step="2" value="1"></uic-stepper>`
        });

        const component = await page.find("uic-stepper");
        const incButton = await page.find(".uic-stepper__increase");
        const decButton = await page.find(".uic-stepper__decrease");

        const uicChange = await component.spyOnEvent("uicChange");

        await incButton.click();
        await page.waitForChanges();

        expect(uicChange).toHaveReceivedEventTimes(1);

        await decButton.click();
        await page.waitForChanges();

        expect(uicChange).toHaveReceivedEventTimes(2);
    });

    it("buttons disable when value equals or exceeds bounds", async () => {
        const page = await newE2EPage({
            html: `<uic-stepper value="5" min="1" max="10"></uic-stepper>`
        });

        const component = await page.find("uic-stepper");
        const decButton = await page.find(".uic-stepper__decrease");
        const incButton = await page.find(".uic-stepper__increase");

        expect(await decButton.getProperty("disabled")).toEqual(false);
        expect(await incButton.getProperty("disabled")).toEqual(false);

        await assertDisabled(page, component, incButton, 10);
        await assertDisabled(page, component, incButton, 100);

        await assertDisabled(page, component, decButton, 1);
        await assertDisabled(page, component, decButton, -100);

        component.setProperty("value", 2);
        await page.waitForChanges();

        expect(await decButton.getProperty("disabled")).toEqual(false);
        expect(await incButton.getProperty("disabled")).toEqual(false);
    });

    describe("Validation", () => {
        it("should set invald when calling reportValidity", async () => {
            const page = await newE2EPage({
                html: `<uic-stepper value="0" min="1" max="10"></uic-stepper>`
            });

            const component = await page.find("uic-stepper");
            const uicInvalid = await component.spyOnEvent("uicInvalid");

            component.callMethod("reportValidity");

            await page.waitForChanges();

            expect(await component.getProperty("invalid")).toEqual(true);
            expect(uicInvalid).toHaveReceivedEvent();
        });
    });

    describe("quickMinMax functionality", () => {
        it("quick maximum button appears when value is set to min and increases to max value on click", async () => {
            const page = await newE2EPage({
                html: `<uic-stepper value="1" min="1" max="10"></uic-stepper>`
            });

            const component = await page.find("uic-stepper");
            component.setProperty("quickMinMax", true);
            await page.waitForChanges();
            const incMaxButton = await page.find("uic-button.uic-stepper__increase_to_max");
            await expect(await incMaxButton.isVisible()).toBeTruthy();

            await incMaxButton.click();
            await page.waitForChanges();
            expect(await component.getProperty("value")).toEqual(10);
        });

        it("quick minimum button appears when value is set to max and decreases to min value on click", async () => {
            const page = await newE2EPage({
                html: `<uic-stepper value="10" min="1" max="10"></uic-stepper>`
            });

            const component = await page.find("uic-stepper");
            component.setProperty("quickMinMax", true);
            await page.waitForChanges();
            const decMinButton = await page.find("uic-button.uic-stepper__decrease_to_min");
            await expect(await decMinButton.isVisible()).toBeTruthy();

            await decMinButton.click();
            await page.waitForChanges();
            expect(await component.getProperty("value")).toEqual(1);
        });
    });
});

async function assertDisabled(page: E2EPage, component: E2EElement, button: E2EElement, val: number) {
    component.setProperty("value", val);
    await page.waitForChanges();

    expect(await button.getProperty("disabled")).toEqual(true);
}
